import React, { useState } from "react";
import { Row, Col, Form, FormControl, Table, Button, OverlayTrigger, Popover,Modal, ModalHeader, ModalBody, ModalFooter } from "react-bootstrap";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { REACT_APP_VAM_CONTEXT_PAYMENT_UPLOAD, REACT_APP_VAM_ENDPOINT } from "../urls";
import { toast } from "react-toastify";
import NoDataFound from "../utilsComponent/noDataFound";
import { axiosRequest } from "../service";
import LoadingPage from "../reusableComponents/loader/loadingPage";
import "../reusableComponents/loader/loader.scss";
import { editModeOn } from "../utilFunctions";
import { functionalities } from "../consts";
const Utrupload = (props) => {
  const {productNames, roleDataCookie} = props
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/dashboard/claim-bulk-process');
  }
  const [showUploadPopover, setShowUploadPopover] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false)
  const [uploadFailed, setUploadFailed] = useState(false)
  const [successfullUploadModal, setSuccessfullUploadModal] = useState(false)
  const [successfullUploadText, setSuccessfullUploadText] = useState(false)
  const [utrLists, setUtrLists] = useState([])
  const [loading, setLoading] = useState(false);
  const refaultSearch = {
    productName: "",
    policyNo: ""
  }
  const [searchFields, setSearchFields] = useState(refaultSearch)
  const [file, setFile] = useState(undefined)

  const handleUploadClick = () => {
    setShowUploadPopover(!showUploadPopover);
  };

  const uploadFile = (id) => {
    const fileInput = document.getElementById(id);
    const file = fileInput.files[0];
    const formData = new FormData();
    if (file) {
      formData.append('paymentUploadfile', file);
      formData.append("userId", roleDataCookie.userID);  
      setLoading(true);
      axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_PAYMENT_UPLOAD}/uploadpayments`, formData)
        .then(data => {
          setSuccessfullUploadText(data.data);
          setSuccessfullUploadModal(true);
        })
        .catch(error => {
          setUploadFailed(true);
        })
        .finally(() => {
          setLoading(false);
          fileInput.value = "";
        });
    }
  };
  const handleSearchClick = () => {
    if(!searchFields.productName && !searchFields.policyNo){
        toast.error("Please Select Product Name or Enter policy Number")
        return
    }
   
    axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_PAYMENT_UPLOAD}/searchPaymentUpload`, {...searchFields, productName: searchFields.productName.value ? String(searchFields.productName.value) : ""}).then(data => {
      setUtrLists(data.data)
  }).catch(error => {
      setUploadFailed(true)
  })
  }

  return (
    <section className="p-4">
      <div className="border rounded p-4 px-1">
        <div className="d-md-flex align-items-center justify-content-around">
          <Row>
            <Col xs={3} className="form-group w-20">
            <label for="exampleInputPassword1">Product Name</label>
                <Select id="exampleInputPassword1" options={productNames}
                    classNamePrefix="bg-gray" placeholder="Select Kshema Product"
                    value={searchFields.productName ? { label: searchFields.productName.label } : null}
                    onChange={(data) => {
                        setSearchFields({
                            ...searchFields,
                            productName: data,
                        })
                    }}
                    isClearable = {true}
                />
            </Col >
            <Col xs={3} className="form-group w-20">
              <label for="exampleInputPassword1">Policy ID</label>
              <input type="text" maxLength={50} className="form-control bg-white" id="exampleInputPassword1" value={searchFields.policyNo} placeholder="Enter Policy ID"  onChange={(e) => {
                     if(/[^A-Za-z\d\/]/.test(e.target.value)){
                      return
                     }
                        setSearchFields({
                            ...searchFields,
                            policyNo: e.target.value,
                        })
                    }}/>
            </Col >
            <Col>
              <div className="form-group">
                <button className="btn btn-success m-4 mb-0 px-4" onClick={() => handleSearchClick()}>Search</button>
                <button className="btn btn-outline-success mt-4 mb-0 px-4" onClick={() => {setSearchFields(refaultSearch);setUtrLists([])}}>Reset</button>
              </div></Col>
          </Row>
        </div>
      </div>
      <Row>
        <Col xs={11}>
          <h2
            className="heading_h2"
          >
           {utrLists && utrLists.length > 0 && "Search Results"}
          </h2>
        </Col>
        { editModeOn(functionalities.CLAIM_BULK_PROCESS_TAB) &&
          <Col xs={1}>
          <label className="btn btn-success mt-4 mb-4 ms-2" for="fileInput">
                <input type="file" id="fileInput" className="w-100" accept=".xls,.xlsx" hidden onChange={() => uploadFile("fileInput")} />
                <span className="px-2">
                    <span className="text-white">Upload</span>
                </span>
            </label>
            {/* <label className="btn btn-success m-4 mb-4" for="fileInput">
              <input type="file" id="fileInput" className="w-100" accept=".xls,.xlsx" hidden onChange={() => uploadFile()}>Upload</input>
            </label> */}
          </Col>
        }
      </Row>
      {loading && (
  <div className="loading-background">
    <LoadingPage />
  </div>
)}

      <div>
        {
          utrLists && utrLists.length > 0 ? (
            <table id="claim_historyclaim">
              <tbody>
                <tr>
                  <th>
                    Application No
                  </th>
                  <th>
                    Claim Type
                  </th>
                  <th>
                    Sub type
                  </th>
                  <th>
                    UTR Number
                  </th>
                  <th>
                    UTR Date
                  </th>
                  <th>
                    Payment Mode
                  </th>
                  <th>
                    PFMS Unique Code
                  </th>
                  <th>
                    Payment Status
                  </th>
                  <th>
                    Payment Channel
                  </th>
                  <th>
                    lot ID
                  </th>
                  <th>
                    Uploaded By
                  </th>
                  <th>
                    Uploaded Date&Time
                  </th>
                </tr>
                {
                  utrLists.map(list => (
                    <tr>
                      <td>{list.applicationNo}</td>
                      <td>{list.claimType}</td>
                      <td>{list.subType}</td>
                      <td>{list.utrNumber}</td>
                      <td>{list.utrDate}</td>
                      <td>{list.paymentMode}</td>
                      <td>{list.pfmsUniqueCode}</td>
                      <td>{list.paymentStatus}</td>
                      <td>{list.paymentChannel}</td>
                      <td>{list.lotID}</td>
                      <td>{list.uploadedBy}</td>
                      <td>{list.uploadedDateAndTime}</td>
                    </tr>
                  ))
                }
              </tbody>
            </table>          
          ) : <NoDataFound text="No Data Found"/>
        }
        {showUploadPopover &&
          <Modal show={showUploadPopover} isOpen={showUploadPopover} toggle={handleUploadClick} centered={true} backdrop={'static'}>
            <ModalHeader toggle={handleUploadClick}>Upload</ModalHeader>
            <ModalBody>
              {uploadSuccess && (
                <div style={{ color: 'green', textAlign: 'center', marginBottom: '10px' }}>
                  Upload Completed
                  <div>
                    <label style={{ color: 'black' }}>
                      Download the Report
                      <a id="link" href="path/to/your/report.pdf" download>Upload 1.xlsx</a>
                    </label>
                  </div>
                </div>

              )}
              {uploadFailed && (
                <div style={{ color: 'red', textAlign: 'center', marginBottom: '10px', height: '100px' }}>
                  <div>
                    Upload Failed
                  </div>
                  <div>
                    <label style={{ color: 'black' }}>Something went wrong
                      uploading files
                    </label>
                  </div>
                  <label className="btn btn-outline-danger mt-4 mb-4 ms-2" for="fileInput_try">
                    <input type="file" id="fileInput_try" className="w-100" accept=".xls,.xlsx" hidden onChange={() => uploadFile("fileInput_try")} />
                    <span className="px-2">
                        <span className="text-white">Try again</span>
                    </span>
                </label>
                </div>
              )}
            </ModalBody>
            <ModalFooter>
            </ModalFooter>
          </Modal>
        }
        {successfullUploadModal &&
        <Modal show={successfullUploadModal} isOpen={successfullUploadModal} toggle={setSuccessfullUploadModal} centered={true} backdrop={'static'}>
            <ModalHeader>File Upload</ModalHeader>
            <ModalBody>
              <>
                  <a className="center">
                      <img src="../kshemaImages/Star.png" alt="Success" width="132px" height="132px" className="center" />
                  </a>
                  <p className="claim_success">{successfullUploadText}</p>
              </>
            </ModalBody>
            <ModalFooter style={{ justifyContent: 'center' }}>
                <Button color="secondary" style={{ borderColor: 'red', backgroundColor: 'transparent', color: 'red' }} onClick={() => setSuccessfullUploadModal(false)}> OK </Button>
            </ModalFooter>
        </Modal>
        }
      </div>
    </section>
  )
};
export default Utrupload;